import { TextField as MuiTextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { getReccurssiveObjectKeys } from '../../utils';

export const TextField = ({ name, fullWidth, sx, ...props }) => {
  const { control } = useFormContext();
  const handleChange = (event, field) => {
    const value = event.target.value;
    const transformedValue = value
      .split(' ')
      .map((word) => {
        if (word === word.toUpperCase()) {
          return word.toUpperCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');

    field.onChange(transformedValue);
  };

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({ field, formState: { errors } }) => (
        <MuiTextField
          error={!!getReccurssiveObjectKeys(errors, name)}
          {...field}
          {...props}
          sx={{
            ...sx,
            '& .MuiInputBase-input': { px: 1, py: 1, fontSize: '1.2rem' },
            '& .MuiInputBase-input:focus': { backgroundColor: '#E0F7F7' },
            '& .Mui-disabled': { backgroundColor: '#f0ffff' },
            ...(props.type === 'radio' && {
              '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
            })
          }}
          fullWidth={fullWidth}
          onChange={(event) => handleChange(event, field)}
          // helperText={errors[name]?.message?.toString()}
        />
      )}
    />
  );
};
